import NewBooking from './NewBooking';

export default NewBooking;